import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { useCardContextValue } from '../state/CardContext';
import { usePropertyInputsContextValue } from '../state/PropertyInputsContext';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyDisplayWrapper = ({
  propertyName
}) => {
  var _propertyDefinitionsR;
  const {
    objectTypeId,
    objectId,
    asyncData: {
      propertyDefinitionsResult
    }
  } = useCardContextValue();
  const {
    getPropertyValue,
    getSavedValue,
    getDraftValue
  } = usePropertyInputsContextValue();
  const propertyDefinition = (_propertyDefinitionsR = propertyDefinitionsResult.data) === null || _propertyDefinitionsR === void 0 ? void 0 : _propertyDefinitionsR.get(propertyName);
  if (!propertyDefinition) {
    return null;
  }
  const value = getPropertyValue(propertyName);
  return /*#__PURE__*/_jsx(FormattedPropertyV2, {
    objectTypeId: objectTypeId,
    objectId: String(objectId),
    property: propertyDefinition.property,
    value: value,
    getSavedValue: getSavedValue,
    getDraftValue: getDraftValue
  });
};
export default PropertyDisplayWrapper;